import { useGlobalState } from '@/hooks';
import { type ITrackingRightPanel, PmtSignUpStep } from '@/modules/pmt/interfaces';
import type { FC } from 'react';
import { MobilePopupHeader } from '../../../../MobilePopupHeader';
import EmailVerification from './EmailVerification';
import SignUp from './SignUp';
import Success from './Success';
import { CloseIcon, CloseIconWrapper, PanelContent, TrackingRightPanelWrapper } from './TrackingRightPanel.styles';

export const TrackingRightPanel: FC<ITrackingRightPanel> = ({ onClose, ...props }) => {
  const { pmtSignUpStep } = useGlobalState();

  const renderView = () => {
    const signUpProps = {
      heroImage: props.heroImage,
      joinUsDesktopMainText: props.joinUsDesktopMainText,
      joinUsSubtext: props.joinUsSubtext,
      desktopGoogleCta: props.desktopGoogleCta,
      identifier: props.identifier,
      subPmcNewsletterText: props.subPmcNewsletterText,
      zapierHookId: props.zapierHookId,
      loginByEmail: props.loginByEmail,
      delayTime: props.delayTime, // for GTM
    };

    const successProps = {
      onClose,
      newsletterSubText: props.newsletterSubText,
      subPmcNewsletterText: props.subPmcNewsletterText,
      zapierHookId: props.zapierHookId,
    };

    switch (pmtSignUpStep) {
      case PmtSignUpStep.SignUp:
        return <SignUp {...signUpProps} />;

      case PmtSignUpStep.VerifyEmail:
        return <EmailVerification />;

      case PmtSignUpStep.Success:
        return <Success {...successProps} />;

      default:
        return null;
    }
  };

  return (
    <TrackingRightPanelWrapper>
      <MobilePopupHeader onClose={onClose} />
      <CloseIconWrapper>
        <CloseIcon aria-label='Close onboarding popup' />
      </CloseIconWrapper>
      <PanelContent>{renderView()}</PanelContent>
    </TrackingRightPanelWrapper>
  );
};
